import { clientsLeadsListOptions, ReturnLeadReadable } from '@crm/api'
import { PhoneNumbers } from '@crm/components'
import { ConditionalText, DayLabel, TableContainer } from '@shared/components'
import { useQueryParams } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { getFullName } from '@shared/utils'
import { useQuery } from '@tanstack/react-query'
import { TableColumnsType } from 'antd'
import { useParams } from 'react-router-dom'

export const ClientLeadsCol = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const params = useQueryParams()

  const { data, isLoading } = useQuery({
    ...clientsLeadsListOptions({
      path: { client_id: id! },
      query: { ...params }
    }),
    enabled: !!id
  })

  const columns: TableColumnsType<ReturnLeadReadable> = [
    {
      title: t('lead.lead_name'),
      key: 'name',
      render: (_, record) => {
        const fullName = getFullName(record.contact)

        return (
          <ConditionalText condition={!!fullName || !!record.name}>
            {fullName || record.name}
          </ConditionalText>
        )
      }
    },
    {
      title: t('contacts.phone_number'),
      render: (_, record) => (
        <PhoneNumbers phoneNumbers={record.contact?.phone_numbers} />
      )
    },
    {
      title: t('contacts.lead_owner'),
      render: (_, record) => (
        <ConditionalText condition={!!record.owner?.name}>
          {record.owner?.name}
        </ConditionalText>
      )
    },
    {
      title: t('contacts.pipeline'),
      render: (_, record) => (
        <ConditionalText condition={!!record.lead_type?.name}>
          {record.lead_type?.name}
        </ConditionalText>
      )
    },
    {
      title: t('contacts.status'),
      key: 'status',
      render: (_, record) => (
        <ConditionalText condition={!!record.status?.name}>
          {record.status?.name}
        </ConditionalText>
      )
    },
    {
      title: t('created_at'),
      key: 'created_at',
      render: (_, { contact }) => <DayLabel date={contact?.created_at} />
    },
    {
      title: t('modified_at'),
      key: 'modified_at',
      render: (_, { contact }) => <DayLabel date={contact?.modified_at} />
    }
  ]

  return (
    <TableContainer
      rowKey="id"
      columns={columns}
      data={data}
      loading={isLoading}
    />
  )
}
